import 'css-chunk:../../src/features/user-settings/components/index.module.scss';export default {
  "image_button": "_image_button_9ps5a_1",
  "active": "_active_9ps5a_13"
};